import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { REVIEWS, AGG } from "@/data/testimonials";

const Stars = ({ n, light }) => (
  <div className="flex gap-0.5" aria-label={`${n} out of 5 stars`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} size={16} className={i <= n ? "text-[#EAB308] fill-[#EAB308]" : light ? "text-white/30" : "text-[#0A1A4A]/20"} />
    ))}
  </div>
);

export const Reviews = () => (
  <section id="reviews" className="bg-[#F3F4F6] border-y-2 border-[#0A1A4A] py-20 sm:py-28">
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12">
        <div>
          <div className="font-mono-accent text-xs tracking-widest uppercase text-[#2563EB] mb-3">/ Reviews</div>
          <h2 className="font-display font-black text-[#0A1A4A] text-4xl sm:text-6xl tracking-tight leading-[0.95]">
            SWANSEA<br /><span className="text-[#2563EB]">RATES US</span>
          </h2>
        </div>
        <div className="bg-[#0A1A4A] text-white p-6 border-2 border-[#0A1A4A] shadow-hard-blue" data-testid="aggregate-rating">
          <div className="flex items-center gap-3">
            <span className="font-mono-accent font-bold text-5xl text-[#EAB308]">{AGG.rating}</span>
            <div>
              <Stars n={5} light />
              <div className="font-mono-accent text-[11px] tracking-widest uppercase text-white/60 mt-1">from {AGG.count} reviews</div>
            </div>
          </div>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {REVIEWS.map((r, i) => (
          <motion.figure
            key={r.name}
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }}
            className="bg-white border-2 border-[#0A1A4A] p-7 flex flex-col" data-testid={`review-${i}`}
          >
            <Quote size={28} className="text-[#2563EB] mb-4" />
            <blockquote className="text-[#0A1A4A]/80 leading-relaxed flex-1">"{r.text}"</blockquote>
            <figcaption className="mt-6 pt-5 border-t border-[#0A1A4A]/10 flex items-center justify-between">
              <div>
                <div className="font-display font-extrabold uppercase text-[#0A1A4A]">{r.name}</div>
                <div className="font-mono-accent text-[11px] tracking-widest uppercase text-[#0A1A4A]/50 mt-0.5">{r.area}</div>
              </div>
              <Stars n={r.rating} />
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
